import { defineMessages } from 'react-intl';

export default defineMessages({
  generateReportTitle: {
    id: 'App.RentForecast.BuildBudget.Title',
    defaultMessage: 'Build Your Budget',
  },
  generateReportSubTitle: {
    id: 'App.RentForecast.BuildBudget.SubTitle',
    defaultMessage:
      'Customize your budget with the fields below, hover over the tooltip for additional information',
  },
  buttonBack: {
    id: 'App.RentForecast.BuildBudget.ButtonBack.Label',
    defaultMessage: 'Back',
  },
  buttonNext: {
    id: 'App.RentForecast.BuildBudget.ButtonNext.Label',
    defaultMessage: 'Next',
  },
  buttonContinue: {
    id: 'App.RentForecast.BuildBudget.ButtonContinue.Label',
    defaultMessage: 'Continue',
  },
  datePickerActualBudgetRange: {
    id: 'App.RentForecast.BuildBudget.ActualBudgetRange.Label',
    defaultMessage: 'What date range do you want to use for the Actual Budget?',
  },
  datePickerActualBudgetFrom: {
    id: 'App.RentForecast.BuildBudget.ActualBudgetFrom.Label',
    defaultMessage: 'Actual Budget From',
  },
  datePickerActualBudgetFromError: {
    id: 'App.RentForecast.BuildBudget.ActualBudgetFrom.Error',
    defaultMessage: 'Date cannot be after end date.',
  },
  datePickerActualBudgetTo: {
    id: 'App.RentForecast.BuildBudget.ActualBudgetTo.Label',
    defaultMessage: 'Actual Budget To',
  },
  datePickerActualBudgetToError: {
    id: 'App.RentForecast.BuildBudget.ActualBudgetTo.Error',
    defaultMessage: 'Date cannot be before start date.',
  },
  dropdownLabelReportType: {
    id: 'App.RentForecast.BuildBudget.ReportType.Label',
    defaultMessage: 'Report Type',
  },
  dropdownLabelCurrentBudget: {
    id: 'App.RentForecast.BuildBudget.CurrentBudget.Label',
    defaultMessage: 'What year do you want to use for the Current Budget?',
  },
  dropdownLabelBudgetPeriod: {
    id: 'App.RentForecast.BuildBudget.BudgetPeriod.Label',
    defaultMessage: 'What budget period are you creating this for?',
  },
  dropdownLabelBudgetType: {
    id: 'App.RentForecast.BuildBudget.BudgetType.Label',
    defaultMessage: 'What type of budget are you creating?',
  },
  dropdownHelperTextBudgetType: {
    id: 'App.RentForecast.BuildBudget.BudgetType.HelperText',
    defaultMessage: 'Select the purpose of this copied budget.',
  },
  dropdownHelperTextBudgetPeriod: {
    id: 'App.RentForecast.BuildBudget.BudgetPeriod.HelperText',
    defaultMessage: 'Select the budget period you would like to create.',
  },
  dropdownLabelComments: {
    id: 'App.RentForecast.BuildBudget.Comments.Label',
    defaultMessage: 'What would you like to show in the Comments?',
  },
  dropdownBudgetPeriodAnnualOption: {
    id: 'App.RentForecast.BuildBudget.BudgetPeriod.Option.Annual.Text',
    defaultMessage: 'Annual',
  },
  dropdownBudgetPeriodQuarterlyOption: {
    id: 'App.RentForecast.BuildBudget.BudgetPeriod.Option.Quarterly.Text',
    defaultMessage: 'Quarterly',
  },
  dropdownBudgetPeriodMonthlyOption: {
    id: 'App.RentForecast.BuildBudget.BudgetPeriod.Option.Monthly.Text',
    defaultMessage: 'Monthly',
  },
  dropdownBudgetTypeInitialOption: {
    id: 'App.RentForecast.BuildBudget.BudgetType.Option.Initial.Text',
    defaultMessage: 'Initial',
  },
  dropdownBudgetTypeRegularReportOption: {
    id: 'App.RentForecast.BuildBudget.BudgetType.Option.RegularReport.Text',
    defaultMessage: 'Regular Report',
  },
  dropdownBudgetTypeRentChangeOption: {
    id: 'App.RentForecast.BuildBudget.BudgetType.Option.RentChange.Text',
    defaultMessage: 'Rent Change',
  },
  dropdownBudgetTypeSMROption: {
    id: 'App.RentForecast.BuildBudget.BudgetType.Option.SMR.Text',
    defaultMessage: 'SMR',
  },
  dropdownBudgetTypeOtherServicingOption: {
    id: 'App.RentForecast.BuildBudget.BudgetType.Option.OtherServicing.Text',
    defaultMessage: 'Other Servicing',
  },
  dropdownCommentsProposedOption: {
    id: 'App.RentForecast.BuildBudget.Comments.Option.ProposedBudget.Text',
    defaultMessage: 'Proposed Budget Comments',
  },
  dropdownCommentsActualsOption: {
    id: 'App.RentForecast.BuildBudget.Comments.Option.ActualsYTD.Text',
    defaultMessage: 'Actuals YTD',
  },
  dropdownCommentsNothingOption: {
    id: 'App.RentForecast.BuildBudget.Comments.Option.Nothing.Text',
    defaultMessage: 'Nothing',
  },
  inputLabelBudgetName: {
    id: 'App.RentForecast.BuildBudget.BudgetName.Label',
    defaultMessage: 'What would you like this budget to be called?',
  },
  radioProposedBudgetFill: {
    id: 'App.RentForecast.BuildBudget.ProposedBudget.Label',
    defaultMessage: 'Do you want to include the Proposed Budget for {year}?',
  },
  radioProposedBudgetFillHelperText: {
    id: 'App.RentForecast.BuildBudget.ProposedBudget.HelperText',
    defaultMessage: 'Select "No" to keep the Proposed Budget column blank.',
  },
  radioIntacctYTDActuals: {
    id: 'App.RentForecast.BuildBudget.IntacctYTDActuals.Label',
    defaultMessage: 'Include YTD Actuals?',
  },
  toastBuildSuccess: {
    id: 'App.RentForecast.BuildBudget.Toast.Build.Success',
    defaultMessage:
      'Rent forecast creation in progress. An email will be sent once the process has finished.',
  },
  toastBuildError: {
    id: 'App.RentForecast.BuildBudget.Toast.Build.Error',
    defaultMessage: 'Could not create budget. Try again later.',
  },
});
